import { useState, useEffect } from "react";

export interface UseLoader {
  isLoading: boolean;
  message: string;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  start: (message?: string) => void;
  done: () => void;
  toggle: (state: boolean) => void;
}

export function useLoader(initialState = false, initialMessage = ""): UseLoader {
  const [isLoading, setIsLoading] = useState(initialState);
  const [message, setMessage] = useState(initialMessage);

  useEffect(() => {
    const body = document.body;
    const container = document.querySelector(".__billing") as HTMLElement;
    const state = isLoading ? "hidden" : "auto";
    body.style.overflow = state;
    if (container) {
      container.style.overflow = state;
    }
  }, [isLoading]);

  /**
   * Start the loader.
   */
  const start = (message?: string) => {
    if (message) {
      setMessage(message);
    }
    setIsLoading(true);
  };

  /**
   * Stop the loader.
   */
  const done = () => {
    setMessage("");
    setIsLoading(false);
  };

  /**
   * Toggle the loader.
   */
  const toggle = (on: boolean) => setIsLoading(on);

  /**
   * Return the hook.
   */
  return {
    isLoading,
    message,
    setMessage,
    start,
    done,
    toggle,
  };
}
